/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export default {
    REPORT: 'reportUnit',
    ADHOC_VIEW: 'adhocDataView',
    REPORT_OPTION: 'reportOptions',
    INPUT_CONTROL: 'inputControl',
    FILTER_GROUP: 'filterGroup',
    WEB_PAGE_VIEW: 'webPageView',
    FREE_TEXT: 'text',
    IMAGE: 'image',
    CROSSTAB: 'crosstab',
    CHART: 'chart',
    TABLE: 'table',
    VALUE: 'value',
    DASHBOARD_PROPERTIES: 'dashboardProperties'
};